import styled from 'styled-components'

import { Body } from '@nx/fire/typography'

export const StyledTime = styled(Body)`
  color: ${({ theme: { colours } }) => colours.status.error};
  margin: 0;
`
